import Vue from "vue";

import Select2 from "./form/Select2.vue";
import DatePicker from './form/DatePicker.vue'
import InstanceCreatingLoader from "./loaders/InstanceCreatingLoader.vue";
import ModalContractPeriod from "./modals/ModalContractPeriod.vue";
import HelpModal from "./help/HelpModal";
import ButtonOpenHelpModal from "./help/ButtonOpenHelpModal";
import ButtonShowModalContractPeriod from "./ButtonShowModalContractPeriod.vue";
import ConnectWithModalButton from "./Payments/ConnectWithModalButton";
import BulkAction from './table/BulkActionButton.vue';
import Paginator from './table/TablePaginationButtons.vue';
import ModalDataLoader from "./Payments/ModalDataLoader";
import ModalGenerateRootOperationBalance from './modals/ModalGenerateRootOperationBalance.vue';
import ButtonShowModalConnectWith from './ButtonShowModalConnectWith.vue'
import ButtonShowModalGenerateBalance from './ButtonShowModalGenerateBalance.vue'
import OperationsHistory from './history-tables/OperationsHistory.vue';
import DocumentsHistory from './history-tables/DocumentsHistory.vue';
import PaymentCorrectionsHistory from './history-tables/PaymentCorrectionsHistory.vue';
import DocumentTemplateSections from './DocumentTemplateSections.vue';
import IncompleteModal from "./transfer-lists/IncompleteModal.vue";
import SortableTableHeader from "./transfer-lists/SortableTableHeader.vue";
import ListHeader from "./transfer-lists/ListHeader.vue";
import RowIcons from "./transfer-lists/RowIcons.vue";
import TruncatedText from "./TruncatedText.vue";
import WrappedText from "./WrappedText.vue";
import ClientDataForm from "./forms/CreateClient/ClientDataForm";
import RegisterSection from "./forms/CreateClient/RegisterSection";
import ModalCreateNewPaymentType from './ModalCreateNewPaymentType.vue';
import ModalEditPaymentType from './ModalEditPaymentType.vue';
import SettingsModal from "../views/sell-or-buy-analyze/SettingsModal";
import ModalEditContractorGroup from "../views/sell-or-buy-analyze/ModalEditContractorGroup";
import ModalCreateItemGroup from "../views/sell-or-buy-analyze/ModalCreateItemGroup";
import ModalAssignToItemGroup from "../views/sell-or-buy-analyze/ModalAssignToItemGroup";


Vue.component("select2", Select2);
Vue.component('datepicker', DatePicker);
Vue.component("instance-creating-loader", InstanceCreatingLoader);
Vue.component("modal-contract-period", ModalContractPeriod);

Vue.component("help-modal", HelpModal);
Vue.component("button-open-help-modal", ButtonOpenHelpModal);

Vue.component("button-contract-period-modal", ButtonShowModalContractPeriod);
Vue.component("connect-with-modal-button", ConnectWithModalButton);
Vue.component('bulk-action', BulkAction);
Vue.component('table-pagination', Paginator);
Vue.component('modal-data-loader', ModalDataLoader);

Vue.component('button-show-modal-connect-with', ButtonShowModalConnectWith);
Vue.component('button-show-modal-generate-balance', ButtonShowModalGenerateBalance);
Vue.component('operations-history', OperationsHistory);
Vue.component('documents-history', DocumentsHistory);
Vue.component('modal-generate-root-operation-balance', ModalGenerateRootOperationBalance);
Vue.component('payment-corrections-history', PaymentCorrectionsHistory);

Vue.component('document-template-sections', DocumentTemplateSections);

Vue.component('incomplete-modal', IncompleteModal);
Vue.component('sortable-th', SortableTableHeader);
Vue.component('row-icons', RowIcons);
Vue.component('list-header', ListHeader)
Vue.component('truncated-text', TruncatedText);
Vue.component('wrapped-text', WrappedText);

Vue.component('client-data-form', ClientDataForm);
Vue.component('register-component', RegisterSection);

Vue.component('modal-create-new-payment-type', ModalCreateNewPaymentType);
Vue.component('modal-edit-payment-type', ModalEditPaymentType);
Vue.component('settings-modal', SettingsModal)
Vue.component('modal-edit-contractor-group', ModalEditContractorGroup)
Vue.component('modal-create-item-group', ModalCreateItemGroup)
Vue.component('modal-assign-to-item-group', ModalAssignToItemGroup)
